import React, { memo, FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Query_shared } from "@/api/shared/index";
import { Query_Imgix } from "@/api/imgix/index";
import { ChallengeOverviewCardProps } from "@/features/challenge/types/props/OverviewProps";
import {
  AspectRatio,
  Avatar,
  Badge,
  Box,
  Card,
  Flex,
  Heading,
  Inset,
  Text,
} from "@radix-ui/themes";
import { ChallengeCardActions } from "./ChallengeCardActions";
import { siteRoutes } from "@/routes/siteRoutesList";

const ChallengeCardComponent: FC<
  ChallengeOverviewCardProps & { isPreview?: boolean }
> = ({ isPlaceholder = false, isPreview, ...props }): JSX.Element => {
  const [logoError, setLogoError] = useState<boolean>(false);

  const navigate = useNavigate();

  const userName = props.author?.userName;
  const author = props.author;

  const url =
    props.zone && props.zone.title
      ? `${siteRoutes["zone"]}${props.zone.slug}${siteRoutes["challengesAndSlug"]}${props.slug}`
      : `${siteRoutes["challengesAndSlug"]}${props.slug}`;

  const isVideo = props.logo.includes("mp4") || props.logo.includes("webm");
  const isMP4 = props.logo.includes("mp4");

  return (
    <Card key={props.key} asChild className="card">
      <Box>
        <Box onClick={() => navigate(url)}>
          <Inset clip="padding-box" side="top" pb="current">
            <AspectRatio ratio={4 / 3}>
              {!isVideo ? (
                <img
                  src={Query_shared.imageErrorHandler(
                    props.logo?.includes("wog.imgix") ||
                      props.logo?.includes("iplay.imgix")
                      ? `${props.logo}?${Query_Imgix.getImgixUrlProps({
                          qty: "100",
                          w: "400",
                        })}`
                      : props.logo,
                    logoError,
                    isPlaceholder
                  )}
                  alt={props.name}
                />
              ) : (
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                >
                  <source
                    src={props.logo}
                    type={`video/${isMP4 ? "mp4" : "webm"}`}
                  />
                </video>
              )}
            </AspectRatio>
            <Box position="absolute" inset="0.75rem auto auto 0.75rem">
              <Badge variant="solid">
                {props.game === "Call of Duty Warzone" ? "Warzone" : props.game}
              </Badge>
            </Box>
          </Inset>

          <Flex direction="column">
            <Heading as="h3" size="3" mb="1">
              {props.name}
            </Heading>

            <Flex wrap="wrap" gap="1">
              {props.fieldToCompare &&
                props.fieldToCompare.map((field, ind) => {
                  return (
                    <Badge variant="outline" key={ind} title={field}>
                      {field}
                    </Badge>
                  );
                })}
            </Flex>

            {/* User */}
            <Flex align="center" gap="2" py="3">
              {/* Avatar */}
              {props.zone ? (
                <Avatar
                  src={props.zone.imageURL}
                  fallback={props.zone.title.slice(0, 1)}
                  radius="full"
                  size="1"
                />
              ) : (
                <Avatar
                  src={author ? author.profileLogoUrl : ""}
                  fallback={author ? userName.slice(0, 1) : "BG"}
                  radius="full"
                  size="1"
                />
              )}

              <Box>
                {/* Username */}
                {props.zone
                  ? props.zone.title && (
                      <Text size="1" my="0" color="gray" truncate>
                        {props.zone.title}
                      </Text>
                    )
                  : userName && (
                      <Text size="1" my="0" color="gray" truncate>
                        {userName}
                      </Text>
                    )}
              </Box>
            </Flex>
          </Flex>
        </Box>
        <ChallengeCardActions
          slug={props.slug}
          name={props.name}
          isCurrUserParticipant={props.isCurrUserParticipant}
          gameType={props.gameType}
          challengeType={"public"}
          status={props.status}
        />
      </Box>
    </Card>
  );
};

export default memo(ChallengeCardComponent);
